export default __webpack_public_path__ + "static/media/Q12.08b48349.jpg";